module.exports = __webpack_public_path__ + "media/configurations/O-X-SX-b6b977b6.png";